import { jsx } from "react/jsx-runtime";
import { useRef, useMemo, useEffect } from "react";
import { VoiceWidgetInTextChat } from "../../components/VoiceWidgetInTextChat.js";
import { VoiceTranscriptBubble } from "./VoiceTranscriptBubble.js";
const VoiceScrollList = ({
  lines,
  widgetEvents,
  onLoginCompleted,
  onLoginFailed
}) => {
  const scrollRef = useRef(null);
  const liveLoginCallbacks = useMemo(
    () => ({ onLoginCompleted, onLoginFailed }),
    [onLoginCompleted, onLoginFailed]
  );
  const items = useMemo(() => {
    const merged = [];
    for (const line of lines) {
      merged.push({ kind: "line", key: `line:${line.id}`, createdAt: line.createdAt, line });
    }
    let firstPromptLoginAt;
    let latestPromptLoginEvent;
    for (const event of widgetEvents) {
      if (event.type === "data-widget-prompt-login") {
        if (firstPromptLoginAt === void 0) firstPromptLoginAt = event.createdAt;
        latestPromptLoginEvent = event;
      }
    }
    if (latestPromptLoginEvent && firstPromptLoginAt !== void 0) {
      merged.push({
        kind: "widget",
        key: "widget:data-widget-prompt-login",
        createdAt: firstPromptLoginAt,
        event: latestPromptLoginEvent
      });
    }
    for (const event of widgetEvents) {
      if (event.type === "data-widget-prompt-login") continue;
      merged.push({ kind: "widget", key: `widget:${event.id}`, createdAt: event.createdAt, event });
    }
    merged.sort((a, b) => a.createdAt - b.createdAt);
    return merged;
  }, [lines, widgetEvents]);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [items]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: scrollRef,
      style: {
        flex: "1 1 auto",
        minHeight: 0,
        width: "100%",
        overflowY: "auto",
        // decisions/078 follow-up — generous top padding so the first
        // transcript bubble doesn't crowd the top edge of the overlay.
        // Extra bottom space so the last rows can scroll under the dock fade.
        padding: "48px 18px 130px",
        background: "transparent",
        display: "flex",
        flexDirection: "column"
      },
      children: /* @__PURE__ */ jsx("div", { style: { width: "100%", maxWidth: 720, margin: "0 auto" }, children: items.length === 0 ? /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            color: "var(--voice-header-fg, #9CA3AF)",
            opacity: 0.5,
            fontSize: 13,
            fontStyle: "italic",
            textAlign: "center",
            paddingTop: 8
          },
          children: "Transcripts will appear here as you speak."
        }
      ) : items.map(
        (item) => item.kind === "line" ? /* @__PURE__ */ jsx(VoiceTranscriptBubble, { line: item.line }, item.key) : /* @__PURE__ */ jsx("div", { style: { width: "100%", marginBottom: 12 }, children: /* @__PURE__ */ jsx(
          VoiceWidgetInTextChat,
          {
            type: item.event.type,
            data: item.event.data,
            liveLoginCallbacks,
            collapseProductCardFeatures: true
          }
        ) }, item.key)
      ) })
    }
  );
};
export {
  VoiceScrollList
};
//# sourceMappingURL=VoiceScrollList.js.map
